module.exports = __webpack_public_path__ + "img/sld_mfm_inv_11_t1_b1_dark.7de33530.svg";